// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"d70713fb","285":"8019242e","320":"86d0071c","399":"a499a6cb","435":"2a57b9d3","480":"35940111","490":"bcae8ec2","505":"bca71d5f","571":"ada9e284","630":"af4422c5","783":"536d4972","810":"857e2ac2","913":"3ed0496e"}[chunkId] + ".chunk.js";
};